module.exports = __webpack_public_path__ + "static/media/category-default.8bbfc01f.svg";